/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Eventtitle1Inputs */

const en_eventtitle1 = /** @type {(inputs: Eventtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event Title`)
};

const de_eventtitle1 = /** @type {(inputs: Eventtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventtitel`)
};

/**
* | output |
* | --- |
* | "Event Title" |
*
* @param {Eventtitle1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const eventtitle1 = /** @type {((inputs?: Eventtitle1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Eventtitle1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_eventtitle1(inputs)
	return de_eventtitle1(inputs)
});
export { eventtitle1 as "eventTitle" }